<template>
    <div class="container remove-padding-margin">
        <div class="header-top bg-white">
            <div class="row justify-content-center align-items-center set-row w-limit">
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img @click="back" src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-7 col-sm-7 col-7 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Tahapan Produksi</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2 remove-padding"></div>
            </div>
        </div>
<!--        <div class="pembatas"></div>-->
        <main class="add-padding-default w-limit">
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="animasi-card  bg-transparent d-flex mar-top-18 mar-bot-18">
                        <div class="font-16 status-login color-206CF" id="langkah3"><span class="font-weight-bold color-206CF">Langkah 3/3</span></div>
                        <div class="font-16 status-login color-206CF" id="langkah4"><span class="font-weight-bold color-206CF">Langkah 4/4</span></div>
                    </div>
                    <div class="text-outlets mar-bottom-16">
                        <div class="font-16">Silahkan pilih apa saja aktivitas produksi yang akan dikerjakan</div>
                    </div>
                    <div class="custom-control custom-checkbox remove-padding" v-for="data in dataProductionActivity.dataTahapan" :key="data.idtahapan">
						<!--<input type="checkbox" class="custom-control-input" v-bind:id="data.idtahapan" :value="data.idtahapan" v-if="data.idtahapan === 8000" checked disabled v-model="dataProductionActivity.checklisttahapan">-->
                        <input type="checkbox" class="custom-control-input" :value="data.idtahapan" v-bind:id="data.idtahapan" v-model="dataProductionActivity.checklisttahapan">
                        <label class="custom-control-label font-colorcheck" @click="cekPengemasan(data.idtahapan)" v-bind:for="data.idtahapan" >{{ data.text }}</label>
                    </div>
                    <div class="text-outlets">
                        <div class="font-12 line-height-18 letter-space-002"><span class="require"></span>pengemasan wajib dilakukan dalam produksi</div>
                    </div>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long"  id="btnNext" @click="post">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="this.dataProductionActivity.isClicked === true"></span>
                        <span id="textBtn2">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "ProductionActivity",
        props:["dataProductionActivity","Pilih_Jenis","dataProductionProses"],
        mounted() {
            $('#langkah3').hide();
            $('#langkah4').hide();
            this.coba()

            this.backButtonPressed(this.back)
            this.smartTrackingView("add_outlet_step4");

        },
        methods:{

            back(){
                if(this.dataProductionProses.inputradio==='ya'){
                    this.$emit('showProductionProcess')
                }else{
                    this.$emit('showproductionpalace', true)
                }
            },
            post(){
                if(this.Pilih_Jenis==="ya"){
                    this.postya()
                }else if(this.Pilih_Jenis==="tidak"){
                    this.posttidk()
                }
            },

            coba(){
              if(this.dataProductionProses.inputradio==='ya'){
                  $('#langkah3').show();
              }else{
                  $('#langkah4').show();
              }
            },

            postya(){
                $('#btnNext').prop('disabled', true);
                this.dataProductionActivity.isClicked= true
                $('#textBtn2').hide();
                this.$emit('PostProductionActivity')
            },
            posttidk(){
                $('#btnNext').prop('disabled', true);
                this.dataProductionActivity.isClicked= true
                $('#textBtn2').hide();
                this.$emit('PostProductionActivityElse')
            },
	        cekPengemasan(idtahapan) {
            	if (idtahapan === "8000") {
		            if ($("#8000").is(":checked")) {
			            this.$toast.warning("Mohon pastikan telah ada minimal 1 karyawan yang melakukan pengemasan")
		            }
	            }
	        }
        }
    }
</script>

<style scoped>

</style>